'use client';

import React, { useState, useEffect } from 'react';
import ButtonOther from '../buttons/button_other';
import CaretIcon from './icons/caret';

/**
 * Renders a horizontal slider component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} [props.limit=1] - The limit of items in the slider.
 * @param {number} [props.focusItem=0] - The index of the focused item.
 * @param {Function} props.slideToClickedMarker - The function to handle slide to clicked marker.
 * @returns {JSX.Element} The rendered HorizontalSlider component.
 */

const HorizontalSlider = ({
  limit = 1,
  focusItem = 0,
  slideToClickedMarker,
  slideLimit = 1,
  handleDirectionClick,
}) => {
  const [markers, setMarker] = useState(
    Array.from({ length: limit }, (_, index) => index),
  );

  useEffect(() => {
    setMarker(Array.from({ length: limit }, (_, index) => index));
  }, [limit]);

  const handleClick = (index) => {
    slideToClickedMarker(index);
  };

  return (
    <div className="w-full mx-auto flex justify-center items-center">
      <div className="hidden sm:flex justify-center w-20">
        <ButtonOther
          classes={`${
            focusItem > 0 ? 'visible' : 'invisible'
          } z-20 rotate-90 rounded-full bg-yellow-60 transition-colors hover:bg-yellow-40 w-8 h-8 flex justify-center items-center`}
          icon={<CaretIcon fill="#000000" />}
          onClick={() => handleDirectionClick('prev')}
          ariaLabel="Previous slide"
        />
      </div>
      <div className="w-fit">
        {markers.map((_, index) => (
          <button
            aria-label={`Slide to position ${index + 1}`}
            key={'marker-' + index}
            className={`${
              focusItem === index ? 'bg-black' : 'bg-black-12.5'
            } rounded-full w-2 h-2 mx-1 my-4 transition-all`}
            onClick={() => handleClick(index)}
          ></button>
        ))}
      </div>
      <div className="hidden sm:flex justify-center w-20">
        <ButtonOther
          classes={`${
            focusItem < slideLimit ? 'visible' : 'invisible'
          } z-20 -rotate-90 rounded-full bg-yellow-60 transition-colors hover:bg-yellow-40 w-8 h-8 flex justify-center items-center`}
          icon={<CaretIcon fill="#000000" />}
          onClick={() => handleDirectionClick('next')}
          ariaLabel="Next slide"
        />
      </div>
    </div>
  );
};

export default HorizontalSlider;
